import PreventDragPropagation from './PreventDragPropagation';

export default PreventDragPropagation;
